import React, { Component } from 'react';
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';
import $ from 'jquery';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ParseOutput from './tabsComponent/ParseOutput';
import MeaningMatchScore from './tabsComponent/MeaningMatchScore';
import FaqExtraction from './tabsComponent/FaqExtraction';
import IntentExtraction from "./tabsComponent/IntentExtraction";
import SlotExtraction from "./tabsComponent/SlotExtraction";
import { VoiceConvLog } from './VoiceConvLog';

export class TestVoice extends Component {
    constructor() {
        super();
        window.DheeVoiceBotApi = {};
        this.state = {
            disableStart: false,
            language: { value: 'ENGLISH', label: 'English' },
            apiKey: '',
            apiSecret: '',
            apiKeyNotAdded: false,
            utData: [],
            debugClickCount: 0,
            showMeaningMatchScore: false
        }
    }

    componentDidMount() {
        if (localStorage.getItem("callId") != null) {
            localStorage.removeItem("callId");
        }
        setTimeout(() => {
            this.initWebsocket();
            this.fetchLanguageApi();
            this.fetchApiKeysApi();
            this.fetchProjectVoiceSettingApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.initWebsocket();
            thisController.fetchLanguageApi(event.projectId);
            thisController.fetchApiKeysApi(event.projectId);
            thisController.fetchProjectVoiceSettingApi(event.projectId);
        });
        var currentPath = window.location.href;
        if (currentPath.includes("/Test/voice/meaning-match-score") && this.state.showMeaningMatchScore === false) {
            this.props.history.push("/projectmgmt/test-and-deploy/Test")
        }

        let testControler = this;

        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/test-and-deploy/Test/voice";
            var path1 = window.origin + "/platform/projectmgmt/test-and-deploy/Test/voice/";
            if (currentPath === path || currentPath === path1) {
                $("#test-transcript").addClass('active');
            } else if (currentPath.includes('/Test/voice/parse-output')) {
                $("#test-parse-output").addClass('active');
            } else if (currentPath.includes('/Test/voice/FaqExtraction')) {
                $("#test-faq-extr").addClass('active');
            } else if (currentPath.includes('/Test/voice/IntentExtraction')) {
                $("#test-intent-extr").addClass('active');
            } else if (currentPath.includes('/Test/voice/SlotExtraction')) {
                $("#test-slot-extr").addClass('active');
            } else if (currentPath.includes("/Test/voice/meaning-match-score")) {
                $("#test-matching-score").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-used-test-voice-debug-tab")).addClass('active')
            }
            $("#test-transcript,#test-parse-output,#test-faq-extr,#test-intent-extr,#test-slot-extr,#test-matching-score")
                .on("click", function () {
                    $("#test-transcript,#test-parse-output,#test-faq-extr,#test-intent-extr,#test-slot-extr,#test-matching-score")
                        .removeClass('active');
                    localStorage.setItem("last-used-test-voice-debug-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();

    }

    fetchLanguageApi(projectId) {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var voiceComponent = this;
        $.ajax({
            url: "/api/project-languages-selected",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            success: function (res) {
                if (res.success === true) {
                    voiceComponent.languageList = [];
                    for (var i = 0; i < res.result.length; i++) {
                        voiceComponent.languageList.push({ "value": res.result[i].code, "label": res.result[i].name })
                    }
                    voiceComponent.state.language = { "value": res.result[0].code, "label": res.result[0].name }
                    voiceComponent.setState(voiceComponent.state);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        })
    }

    getProjectDetails = () => {
        var statusController = this;
        $.ajax({
            url: "/api/project-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.deployed == true) {
                        statusController.projectDeployDetails();
                    } else {
                        statusController.notifyNotAdded("Oops!you have not deployed your project")
                        var voiceInterval = setInterval(function () {
                            clearTimeout(voiceInterval);
                            window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
                        }, 3000);
                    }
                } else {
                    statusController.notifyNotAdded("Oops!you have not deployed your project")
                    var voiceInterval = setInterval(function () {
                        clearTimeout(voiceInterval);
                        window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
                    }, 3000);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchApiKeysApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var apiController = this;
        var apis = [];
        $.ajax({
            url: "/api/api-key/api-type",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                apiType: "BOT_API"
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        var apiData = res.result;
                        for (var i = 0; i < apiData.length; i++) {
                            if (apiData[i].apiType == "BOT_API") {
                                apis.push(apiData[i]);
                            }
                        }
                        apiController.state.apiKey = apis[0].key;
                        apiController.state.apiSecret = apis[0].secret;
                        apiController.setState(apiController.state);
                    } else {
                        apiController.state.apiKeyNotAdded = true;
                        apiController.setState(apiController.state);
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchProjectVoiceSettingApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
              projectId = localStorage.getItem('currentProjectId');
            }
          }
        var voiceController = this;
        var enableVoice = false;
        $.ajax({
            url: "/api/voice-settings",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        enableVoice = res.result.enabled;
                    } else {
                        enableVoice = false;
                    }
                } else {
                    enableVoice = false;
                }
                if (!enableVoice) {
                    voiceController.notifyNotAdded("Oops!you have not enabled Voice Capability");
                    var voiceAgentInterval = setInterval(function () {
                        clearTimeout(voiceAgentInterval);
                        window.location.href = '/platform/projectmgmt/voice';
                    }, 2000);
                } else if (voiceController.state.apiKeyNotAdded) {
                    voiceController.notifyNotAdded("Oops!you have not added Api Keys");
                    var voiceInterval = setInterval(function () {
                        clearTimeout(voiceInterval);
                        window.location.href = '/platform/projectmgmt/api-keys';
                    }, 2000);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }


    projectDeployDetails = () => {
        var voiceController = this;
        $.ajax({
            url: "/api/project-deploy-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.projectDeployment.numberOfBots == 0) {
                        voiceController.notifyNotAdded("Oops!you have not deployed your project")
                        var voiceInterval = setInterval(function () {
                            clearTimeout(voiceInterval);
                            window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
                        }, 3000);
                    }
                } else {
                    voiceController.notifyNotAdded("Oops!you have not deployed your project")
                    var voiceInterval = setInterval(function () {
                        clearTimeout(voiceInterval);
                        window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
                    }, 3000);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyNotAdded(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }

    notifyFailToLoadData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyFailToCreateVoiceCall(falseRes) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{falseRes}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    initWebsocket() {
        var socket;
        var microphoneStreamSource;
        var micSourceForAudioMeter;
        var audioPromise;
        var audioContext;
        var startTime;
        var meter;
        var VoiceComponent = this;

        audioPromise = navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: true
            },
            video: false
        });

        function newWebsocket(callId) {
            if (window.DheeVoiceBotApi.lastWebSocket) {
                var lastWebSocket = window.DheeVoiceBotApi.lastWebSocket;
                if (lastWebSocket.readyState === lastWebSocket.CONNECTING || lastWebSocket.readyState === lastWebSocket.OPEN) {
                    return;
                }
            }

            var websocketPromise = new Promise(function (resolve, reject) {
                var protocol = 'ws://';
                if (window.location.protocol.indexOf("https") !== -1) {
                    protocol = 'wss://';
                }

                var callConnectionUrl = "wss://developers.dhee.ai/talk/";
                if (window.location.hostname.includes('dev-')) {
                    callConnectionUrl = 'wss://dev-cloud.dhee.net.in/talk/'
                }

                socket = new WebSocket(callConnectionUrl + callId);
                socket.binaryType = "arraybuffer";
                socket.addEventListener('open', resolve);
                socket.addEventListener('error', reject);
                /*socket.onmessage = function (event) {
                    console.debug("WebSocket message received:", event);
                };*/

                return socket;

            });

            Promise.all([audioPromise, websocketPromise]).then(function (values) {

                var micStream = values[0];
                var socket = values[1].target;

                audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 8000 });

                var websocketProcessorScriptNode = audioContext.createScriptProcessor(256, 1, 1);

                websocketProcessorScriptNode.addEventListener('audioprocess', function (e) {
                    var inputData = e.inputBuffer.getChannelData(0);

                    // Convert float audio data to 16-bit PCM
                    const buffer = new ArrayBuffer(inputData.length * 2);
                    const view = new DataView(buffer);
                    for (let i = 0; i < inputData.length; i++) {
                        const sample = inputData[i] * 0x7fff; // Convert to signed 16-bit PCM
                        view.setInt16(i * 2, sample, true); // Store as little-endian
                    }

                    // Send audio data to the server
                    socket.send(buffer);

                });

                window.DheeVoiceBotApi.websocketProcessorScriptNode = websocketProcessorScriptNode;


                socket.addEventListener('close', function (e) {
                    console.log("websocket closed");
                    cleanUp(VoiceComponent);
                });
                socket.addEventListener('error', function (e) {
                    console.log('Error from websocket', e);
                    cleanUp(VoiceComponent);
                });
                //socket.addEventListener('message', onTranscription);
                socket.addEventListener('message', function (message) {
                    setTimeout(function () {
                        playDheeAudio(message)
                    }, 0);
                });
                function sendInitParams() {
                    var config = {
                        callKey: callId
                    }
                    socket.send(JSON.stringify(config));
                }

                function startByteStream(e) {
                    // Hook up the websocketProcessorScriptNode to the mic
                    microphoneStreamSource = audioContext.createMediaStreamSource(micStream);
                    microphoneStreamSource.connect(websocketProcessorScriptNode);
                    websocketProcessorScriptNode.connect(audioContext.destination);
                    /*micSourceForAudioMeter = audioContext.createMediaStreamSource(micStream);
                    meter = createAudioMeter(audioContext);
                    micSourceForAudioMeter.connect(meter);*/
                }

                var audioId;
                
                const concat = (buffer1, buffer2) => {
                    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);

                    tmp.set(new Uint8Array(buffer1), 0);
                    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);

                    return tmp.buffer;
                };

                const wavify = (data, numberOfChannels, sampleRate) => {
                    const header = new ArrayBuffer(44);

                    var d = new DataView(header);

                    d.setUint8(0, "R".charCodeAt(0));
                    d.setUint8(1, "I".charCodeAt(0));
                    d.setUint8(2, "F".charCodeAt(0));
                    d.setUint8(3, "F".charCodeAt(0));

                    d.setUint32(4, data.byteLength / 2 + 44, true);

                    d.setUint8(8, "W".charCodeAt(0));
                    d.setUint8(9, "A".charCodeAt(0));
                    d.setUint8(10, "V".charCodeAt(0));
                    d.setUint8(11, "E".charCodeAt(0));
                    d.setUint8(12, "f".charCodeAt(0));
                    d.setUint8(13, "m".charCodeAt(0));
                    d.setUint8(14, "t".charCodeAt(0));
                    d.setUint8(15, " ".charCodeAt(0));

                    d.setUint32(16, 16, true);
                    d.setUint16(20, 1, true);
                    d.setUint16(22, numberOfChannels, true);
                    d.setUint32(24, sampleRate, true);
                    d.setUint32(28, sampleRate * 1 * 2);
                    d.setUint16(32, numberOfChannels * 2);
                    d.setUint16(34, 16, true);

                    d.setUint8(36, "d".charCodeAt(0));
                    d.setUint8(37, "a".charCodeAt(0));
                    d.setUint8(38, "t".charCodeAt(0));
                    d.setUint8(39, "a".charCodeAt(0));
                    d.setUint32(40, data.byteLength, true);

                    return concat(header, data);
                };

                let currentlyFilledBufferChain = [];
                let audioBufferChains = [];
                let audioEnded = false;
                let alreadyProcessing = false;
                let playingBufferChain = null;
                let firstBunch = false;

                    
                function playDheeAudio(message) {
                    if (typeof message.data === "string") {

                        console.log("Got Text: " + message.data);
                        if (message.data.startsWith('startAudioStream')) {
                            audioId = message.data.replace("startAudioStream:", "");
                            console.log("initialising audio stream " + audioId);
                            audioEnded = false;
                            currentlyFilledBufferChain = [];
                            audioBufferChains.push(currentlyFilledBufferChain);
                            window.dheeAudioStartTime = audioContext.currentTime;

                        } else if (message.data.startsWith('endAudioStream')) {
                            audioEnded = true;
                            startPlayingBufferchains();
                        }
                        return;
                    }

                    currentlyFilledBufferChain.push(message.data);
                    
                };

                
                function startPlayingBufferchains() {
                    if (alreadyProcessing === true) {
                        return;
                    }
                    alreadyProcessing = true;
                    console.log("Fresh audio processing");
                    setTimeout(function() {
                        consumeBufferChain();
                    }, 5);
                }

                function consumeBufferChain() {

                    if (playingBufferChain == null || playingBufferChain.length == 0) {
                        if (audioBufferChains.length > 0) {
                            playingBufferChain = audioBufferChains.shift();
                            firstBunch = true;
                            console.log("Playing new audio");
                        } else {
                            alreadyProcessing = false;
                            return;
                        }
                    }


                    if(playingBufferChain.length > 0) {

                        var largerSetOfPackets = [];

                        for( var i=0; i < 12; i++) {
                            if (playingBufferChain.length == 0) {
                                break;
                            }
                            largerSetOfPackets.push(playingBufferChain.shift());
                        }
    
                        let mergedPackets = new Uint8Array(largerSetOfPackets.length * 256);
                        let offset = 0;
    
                        largerSetOfPackets.forEach(function (packet) {
                            mergedPackets.set(new Uint8Array(packet), offset);
                            offset += packet.byteLength;
                        });
                        
                        var bytesToDecode;
    
                        if (firstBunch === true) {
                            //THE FIRST PACKET ALREADY HAS HEADERS
                            bytesToDecode = mergedPackets.buffer;
                            firstBunch = false;
                        } else {
                            //ADD WAV HEADERS
                            bytesToDecode = wavify(mergedPackets.buffer, 1, 8000);
                        }
                        audioContext.decodeAudioData(bytesToDecode, function (data) {
                            /*console.log("decoded audio of len:%s, sampleRate:%s, numberOfChannels:%s, duration:%s",
                                data.length, data.sampleRate, data.numberOfChannels, data.duration);*/
                            playSound(data, window.dheeAudioStartTime);
                            window.dheeAudioStartTime += data.duration;
                            setTimeout(function() {
                                consumeBufferChain();
                            }, 5);
                        }, function (e) {
                            console.error("Error decoding data:" + e);
                        });
                        
                    } else {
                        playingBufferChain = null;
                    }
                    
                }
                
                function playSound(buffer, playTime) {
                    //console.log("playing buffer")
                    var source = audioContext.createBufferSource();
                    source.buffer = buffer;
                    source.connect(audioContext.destination);
                    source.onended = function () {
                        source.disconnect(audioContext.destination);
                    }
                    if (!playTime) {
                        playTime = audioContext.currentTime;
                    }
                    source.start(playTime);
                    if (!window.dheeAudioStartTime) {
                        window.dheeAudioStartTime = playTime;
                    }

                }

                sendInitParams();
                startByteStream();

            }).catch(console.log.bind(console));
        }

        function closeWebsocket() {
            try {
                if (socket && socket.readyState === socket.OPEN) {
                    socket.close();
                }
            } catch (error) {
                console.error(error);
            }
        }

        function cleanUp(VoiceComponent) {
            try {
                console.log("cleaning up connections");
                if (window.DheeVoiceBotApi.websocketProcessorScriptNode) {
                    window.DheeVoiceBotApi.websocketProcessorScriptNode.disconnect();
                }
                if (microphoneStreamSource) {
                    microphoneStreamSource.disconnect();
                }
                if (meter) {
                    meter.shutdown();
                }
                if (audioContext) {
                    audioContext.close();
                }
                VoiceComponent.resetCallButtons();
            } catch (error) {
                console.error(error);
            }
        }

        window.DheeVoiceBotApi.newWebsocket = newWebsocket;
        window.DheeVoiceBotApi.closeWebsocket = closeWebsocket;

    }

    startStream = () => {
        this.state.disableStart = true;
        this.setState(this.state);
        var lang = this.state.language.value.toLowerCase();
        if (!lang) {
            lang = 'hindi';
        }
        var VoiceComponent = this;
        //POST to cloud runtime and call Id
        var callCreationUrl = 'https://developers.dhee.ai/api/get-voice-channel';
        if (window.location.hostname.includes('dev-')) {
            callCreationUrl = 'https://dev-cloud.dhee.net.in/api/get-voice-channel'
        }
        function initiateVoiceCall(lang) {
            var config = {
                apiKey: VoiceComponent.state.apiKey,
                apiSecret: VoiceComponent.state.apiSecret,
                customerName: JSON.parse(localStorage.getItem("user_details")).name,
                contactNumber: JSON.parse(localStorage.getItem("user_details")).mobileNumber,
                language: VoiceComponent.state.language.value,
                initMode: "INBOUND",
                voiceGender: "FEMALE",
                callParams: {}
            }
            var callId = false;

            $.ajax({
                url: callCreationUrl,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(config),
                success: function (res) {
                    if (res.success === true) {
                        callId = res.result;
                        console.log("Got callId :" + callId);
                        localStorage.setItem("callId", callId);
                        window.DheeVoiceBotApi.newWebsocket(callId);
                    } else {
                        VoiceComponent.notifyFailToCreateVoiceCall(res.result);
                        VoiceComponent.resetCallButtons();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                   // console.error("Error while getting voice call key" + error);
                    VoiceComponent.resetCallButtons();
                }
            })

            //socket.send(JSON.stringify(config));
        }
        initiateVoiceCall(lang);
    }

    closeStream = () => {
        window.DheeVoiceBotApi.closeWebsocket();
    }

    toggleCall = () => {
        if (this.state.disableStart) {
            this.closeStream();
        } else {
            this.startStream();
        }
    }

    resetCallButtons = () => {
        this.state.disableStart = false;
        this.setState(this.state);
    }

    handleLangChange = (e) => {
        this.state.language = { value: e.value, label: e.label }
        this.setState(this.state);
    }

    routeToReferenceDoc = () => {
        window.open("https://github.com/DheeYantra/dhee-voicebot-api-js", "_blank")
    }

    onClickDebugInsight = () => {
        this.state.debugClickCount = this.state.debugClickCount + 1;
        this.setState(this.state);
        if (this.state.debugClickCount == 6) {
            this.state.showMeaningMatchScore = true;
            this.setState(this.state);
        }
    }

    onclickMouseMoveOut = () => {
        this.state.debugClickCount = 0;
        this.setState(this.state);
    }

    render() {
        return (
            <div style={{ marginLeft: '1%', marginTop: "2%" }}>
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link rel="stylesheet" href="./assets/css/react.table.border.css" />
                <link rel="stylesheet" href="./assets/css/configBot.css" />
                <div className="wrapper">
                    <div className="content" id="configBotcontainer">
                        <div className="container-fluid">
                            <div className="row">

                                <div className="col-lg-5" style={{ marginTop: "10px", borderRadius: "10px" }}>
                                    <div className="card_container">
                                        <div className="col-lg-12 p-0">
                                            <div className="row">
                                                <div className="col-12">
                                                    {/* Custom Tabs */}
                                                    <h6 className="nav-item" style={{
                                                        color: '#282a65',
                                                        marginTop: '10px', marginLeft: '20px'
                                                    }}>Voice Call Demo</h6>

                                                    <ToastContainer className="Toast-at-center" />

                                                    <div className="card-body p-0 mb-25" style={{ marginLeft: "20px" }}>

                                                        <div className="card-body raise-form" style={{ height: "520px" }} Align="center">
                                                            <div Align="center"
                                                                style={{ marginTop: "20px", border: "1px solid #282a65", borderRadius: "10px", height: "300px" }}>
                                                                <div className="col-sm-12" style={{ marginLeft: "70px", marginTop: "60px" }}>
                                                                    <div className="col-sm-8" Align="right">
                                                                        <Select
                                                                            value={this.state.language}
                                                                            onChange={this.handleLangChange}
                                                                            options={this.languageList}
                                                                            id="language"
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-3" Align="left">
                                                                        <button style={{ backgroundColor: "#ffffff", border: "none", display: this.state.disableStart ? "block" : "none" }}><img style={{ width: "50px", height: "50px" }} src="./assets/images/ongoing-call.gif" /></button>
                                                                    </div>
                                                                </div>
                                                                <div Align="center" style={{ marginTop: "150px" }}>
                                                                    <button onClick={this.toggleCall} style={{ backgroundColor: "#ffffff", border: "none" }}><img style={{ width: "50px", height: "50px" }} src={this.state.disableStart ? "./assets/images/red-call.png" : "./assets/images/green-call.png"} /></button>
                                                                </div><br />
                                                                <h6>Please use your headphones to minimise echo.</h6>
                                                            </div >
                                                            {/* <div className="col-sm-3"></div> */}
                                                            <br />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div >
                                    </div>
                                </div>


                                <div className="col-lg-7" style={{ marginTop: "10px", borderRadius: "10px" }}>
                                    <div className="card_container" style={{ height: 'auto' }}>
                                        <div className="col-lg-12 p-0" id="style-1">
                                            <ul className="nav nav-pills mr-auto configNav" style={{ padding: '0.3rem 0rem 0' }}>
                                                <li className="nav-item nav-link active show">
                                                    <h3 className="card-title configBoxTitle"
                                                        onClick={this.onClickDebugInsight} onMouseOut={this.onclickMouseMoveOut}>Debug Insights</h3>
                                                </li>
                                            </ul>
                                            <div className="container-fluid" >
                                                {/* Nav tabs */}
                                                <div className="tab-class ">
                                                    <ul className="nav nav-tabs navCluster border-bottom p-0" >
                                                        <Link to="/projectmgmt/test-and-deploy/Test/voice" style={{ textDecoration: 'none' }}>
                                                            <li className="nav-item nav-link" id="test-transcript"> Transcript</li></Link>

                                                        <Link to="/projectmgmt/test-and-deploy/Test/voice/parse-output" style={{ textDecoration: 'none' }}>
                                                            <li className="nav-item nav-link" id="test-parse-output"> Parse</li></Link>

                                                        <Link to="/projectmgmt/test-and-deploy/Test/voice/meaning-match-score" style={{ display: this.state.showMeaningMatchScore ? "block" : "none", textDecoration: 'none' }}>
                                                            <li className="nav-item nav-link" id="test-matching-score">
                                                                Meaning <br /> Matches
                                                            </li></Link>
                                                        <Link to="/projectmgmt/test-and-deploy/Test/voice/FaqExtraction" style={{ textDecoration: 'none' }}>
                                                            <li className="nav-item nav-link" id="test-faq-extr">
                                                                Extract Faq</li></Link>

                                                        <Link to="/projectmgmt/test-and-deploy/Test/voice/IntentExtraction" style={{ textDecoration: 'none' }}>
                                                            <li className="nav-item nav-link" id="test-intent-extr">
                                                                Extract Intent</li>
                                                        </Link>
                                                        <Link to="/projectmgmt/test-and-deploy/Test/voice/SlotExtraction" style={{ textDecoration: 'none' }}>
                                                            <li className="nav-item nav-link" id="test-slot-extr">
                                                                Extract Slot</li>
                                                        </Link>

                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="card-body p-0">
                                                <div className="tab-content col-12 p-0">
                                                    <Switch>
                                                        <Route path="/projectmgmt/test-and-deploy/Test/voice/SlotExtraction" component={SlotExtraction}></Route>
                                                        <Route path="/projectmgmt/test-and-deploy/Test/voice/IntentExtraction" component={IntentExtraction}></Route>
                                                        <Route path="/projectmgmt/test-and-deploy/Test/voice/FaqExtraction" component={FaqExtraction}></Route>
                                                        <Route path="/projectmgmt/test-and-deploy/Test/voice/meaning-match-score" component={MeaningMatchScore}></Route>
                                                        <Route path="/projectmgmt/test-and-deploy/Test/voice/parse-output" component={ParseOutput}></Route>
                                                        <Route path="/projectmgmt/test-and-deploy/Test/voice" component={VoiceConvLog}></Route>
                                                    </Switch>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/TestVoice.js